import Tour from '@/services/tour'

const fetchFinishTour = async (context, obj) => {
  return new Promise((resolve, reject) => {
    Tour.end().then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

export default {
  fetchFinishTour
}



// WEBPACK FOOTER //
// ./src/features/tours/store/actions.js